import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BlueButton } from "../../../components/attributes/Button";
import FieldTextState from "../../../components/field/Field.TextState";
import Container from "../../../components/layouts/Container";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_COMPLETE_PROFILE,
  TEXT_EMAIL,
  TEXT_FULL_NAME,
  TEXT_NEXT,
} from "../../../utils/useConstants";
import {
  STYLE_ADDRESS_BG,
  STYLE_BUTTON_BLUE,
  STYLE_BUTTON_BLUE_DISABLED,
  STYLE_HEIGHT_BAR,
  STYLE_LOGIN_BAR,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_SCREEN_FULL,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";
import LoginUpdateProfile from "../function/Login.UpdateProfile";
import OurserviceFirstLoad from "../../select/functions/Ourservice.FirstLoad";

const LoginCompleteProfile = ({ mongoId, contry = "", username }) => {
  const { language } = React.useContext(ContextLanguage);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [fullname, setFullname] = React.useState("");
  const [email, setEmail] = React.useState("");

  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    OurserviceFirstLoad();
  }, []);

  // console.log("LoginCompleteProfile", {
  //   mongoId,
  //   contry,
  //   username,
  //   fullname,
  //   email,
  // });

  return (
    <div className={STYLE_SCREEN_FULL}>
      <div className=" bg-white md:bg-transparent">
        <Container>
          <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
            <div className={STYLE_ADDRESS_BG}>
              <ProgramGoBack
                onClick={() => {}}
                title={TEXT_COMPLETE_PROFILE[language]}
                // textcolor=" col-span-4 md:col-span-1 "
                absolute={`${
                  language === "EN"
                    ? "left-[25%] md:left-1/2 md:transform md:-translate-x-1/2"
                    : "left-[30%] md:left-1/2 transform md:-translate-x-1/2"
                }`}
                classname="mb-2.5 md:mb-6.5"
              />

              <div className="space-y-4">
                <FieldTextState
                  name="fullname"
                  icon={
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.4871 12.7891C7.2641 12.7891 4.51172 13.2764 4.51172 15.228C4.51172 17.1795 7.24664 17.6843 10.4871 17.6843C13.7101 17.6843 16.4617 17.1962 16.4617 15.2454C16.4617 13.2946 13.7276 12.7891 10.4871 12.7891Z"
                        stroke="CurrentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.4874 10.0052C12.6025 10.0052 14.3168 8.29015 14.3168 6.17507C14.3168 4.05999 12.6025 2.3457 10.4874 2.3457C8.37233 2.3457 6.65725 4.05999 6.65725 6.17507C6.65011 8.283 8.35328 9.99808 10.4604 10.0052H10.4874Z"
                        stroke="CurrentColor"
                        strokeWidth="1.42857"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  label={TEXT_FULL_NAME[language]}
                  setValue={setFullname}
                  value={fullname}
                />
                <FieldTextState
                  name="email"
                  icon={
                    <svg
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 5.83366C18 4.91318 17.2538 4.16699 16.3333 4.16699H4.66667C3.74619 4.16699 3 4.91318 3 5.83366M18 5.83366V14.167C18 15.0875 17.2538 15.8337 16.3333 15.8337H4.66667C3.74619 15.8337 3 15.0875 3 14.167V5.83366M18 5.83366L10.5 10.8337L3 5.83366"
                        stroke="CurrentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  }
                  label={TEXT_EMAIL[language]}
                  setValue={setEmail}
                  value={email}
                  onKeyPress={(e) => {
                    if (loading) return;
                    if (e.key === "Enter") {
                      LoginUpdateProfile(
                        { full_name: fullname, email },
                        mongoId,
                        navigate,
                        dispatch,
                        contry,
                        username,
                        setLoading,
                        user
                      );
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="w-full bg-white">
        <div
          className={`${STYLE_LOGIN_BAR} ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_HEIGHT_BAR}`}
        >
          <BlueButton
            onClick={() => {
              if (loading) return;
              LoginUpdateProfile(
                { full_name: fullname, email },
                mongoId,
                navigate,
                dispatch,
                contry,
                username,
                setLoading,
                user
              );
            }}
            className={
              loading
                ? STYLE_BUTTON_BLUE_DISABLED(language)
                : fullname && email
                ? STYLE_BUTTON_BLUE(language)
                : STYLE_BUTTON_BLUE_DISABLED(language)
            }
            title={TEXT_NEXT[language]}
            onSubmit={() => {
              if (loading) return;
              LoginUpdateProfile(
                { full_name: fullname, email },
                mongoId,
                navigate,
                dispatch,
                contry,
                username,
                setLoading,
                user
              );
            }}
          />
        </div>
      </div>
      {/* <ButtonSubmitController
        classNameSubmit="w-full"
        labelSubmit={
          <div
            className={`${STYLE_LOGIN_BAR} ${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_HEIGHT_BAR}`}
          >
            <BlueButton
              onClick={() => {
                if (loading) return;
                LoginUpdateProfile(
                  { full_name: fullname, email },
                  mongoId,
                  navigate,
                  dispatch,
                  contry,
                  username,
                  setLoading,
                  user
                );
              }}
              className={
                loading
                  ? STYLE_BUTTON_BLUE_DISABLED(language)
                  : fullname && email
                  ? STYLE_BUTTON_BLUE(language)
                  : STYLE_BUTTON_BLUE_DISABLED(language)
              }
              title={TEXT_NEXT[language]}
              onSubmit={() => {
                if (loading) return;
                LoginUpdateProfile(
                  { full_name: fullname, email },
                  mongoId,
                  navigate,
                  dispatch,
                  contry,
                  username,
                  setLoading,
                  user
                );
              }}
            />
          </div>
        }
      /> */}
    </div>
  );
};
export default LoginCompleteProfile;
